import { NgModule } from "@angular/core";
import { ClientPanelRoutingModule } from "./client-panel-routing.module";
import { FormsModule } from "@angular/forms";
import { DialogModule } from "primeng/dialog";
import { BrowserModule } from "@angular/platform-browser";
import { CollapseDirective } from "./collapse.directive";
import { TimelineModule } from "primeng/timeline";
import { AddTrackComponent } from "./add-track/add-track.component";
import { RippleModule } from "primeng/ripple";
import { TracksListComponent } from "./tracks-list/tracks-list.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { CommonModule } from "@angular/common";
import { DataViewModule } from 'primeng/dataview';
import { SelectButtonModule } from 'primeng/selectbutton';
import { StatusFilterPipe } from "./filters/status-filter.pipe";
import { BadgeModule } from 'primeng/badge';
import { TooltipModule } from "primeng/tooltip";
import { SidebarModule } from 'primeng/sidebar';
import { InputTextModule } from 'primeng/inputtext';
import { StatusCountFilterPipe } from "./filters/status-count-filter.pipe";
import { ClientPanelComponent } from "./client-panel/client-panel.component";
import { ButtonModule } from "primeng/button";
import { SelectModule } from 'primeng/select';

@NgModule({
    imports:[
        BrowserModule,
        BrowserAnimationsModule,
        CommonModule,
        FormsModule,
        ClientPanelRoutingModule,
        ButtonModule,
        DialogModule,
        TimelineModule,
        RippleModule,
        DataViewModule,
        SelectButtonModule,
        BadgeModule,
        TooltipModule,
        InputTextModule,
        SidebarModule,
        SelectModule,
    ],
    declarations: [
        ClientPanelComponent,
        CollapseDirective,
        AddTrackComponent,
        TracksListComponent,
        StatusFilterPipe,
        StatusCountFilterPipe,
    ]
})
export class ClientPanelModule {};